const leadingZeros = (number, qty = 8) => number.toString().padStart(qty,'0').slice(-qty);

export default leadingZeros;